module.exports = __webpack_public_path__ + "static/img/earth_bump.55b3930.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/earth_bump.jpg
// module id = 163
// module chunks = 1